import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = { size?: Unit; color?: Color };
export const Reward = ({
  size = 2,
  color = 'var(--c-rewards-orange)',
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_16952_7786)">
        <path
          d="M10.2129 9.55251L6.00069 11.3617L1.78843 9.55251V6.0225L5.76315 7.7295L6 7.83239L6.23685 7.7295L10.2123 6.02181L10.2129 9.55251Z"
          stroke={color}
          strokeWidth="1.2"
        />
        <path
          d="M10.8013 4.12557L10.802 5.35817L10.8027 5.75385L10.4388 5.90922L6.23754 7.71427L6.00138 7.81647L5.76384 7.71427L1.56332 5.90991L1.2001 5.75385V5.35886L1.19872 4.12695L1.19803 3.21475L2.03564 3.57452L6 5.27669L9.96436 3.57452L10.8006 3.21613L10.8013 4.12557Z"
          stroke={color}
          strokeWidth="1.2"
        />
        <path
          d="M10.7908 3.2207L5.99918 5.27918L1.20619 3.2207V2.69728L5.9978 0.638795L10.7908 2.69728V3.2207Z"
          stroke={color}
          strokeWidth="1.2"
        />
        <path d="M6 5.1001V10.7548" stroke={color} strokeWidth="1.2" />
        <path
          d="M4.94842 2.43388C5.18779 2.4519 5.43003 2.43063 5.65425 2.37196C5.87846 2.31329 6.07796 2.2191 6.23551 2.09737C6.24162 2.09227 6.24975 2.08853 6.25895 2.08641C6.26815 2.08429 6.27811 2.08398 6.28759 2.08555C6.29707 2.08712 6.30568 2.09044 6.31235 2.09518C6.31912 2.09985 6.32365 2.10575 6.32567 2.11216C6.37446 2.27005 6.47998 2.41767 6.63294 2.54232C6.78591 2.66697 6.98179 2.76495 7.20377 2.82769C7.21257 2.83023 7.22011 2.83426 7.22561 2.83951C7.23112 2.84477 7.2344 2.85086 7.23497 2.85721C7.23554 2.86355 7.2334 2.86989 7.22884 2.87552C7.22429 2.88114 7.2175 2.8858 7.20927 2.88895C6.99964 2.96856 6.82226 3.08125 6.69236 3.21713C6.56246 3.35302 6.48401 3.50803 6.4638 3.66884C6.46282 3.67518 6.45932 3.68126 6.45361 3.68637C6.44789 3.69147 6.44014 3.69534 6.43123 3.69766C6.42233 3.69998 6.41275 3.70067 6.40326 3.69949C6.39378 3.69831 6.38518 3.69551 6.37793 3.69129C6.19987 3.58272 5.98499 3.50465 5.75194 3.46391C5.5189 3.42316 5.27467 3.42093 5.04033 3.45737C5.03104 3.45878 5.02136 3.45838 5.01227 3.45629C5.00318 3.4542 4.99535 3.4505 4.98916 3.44556C4.98317 3.44063 4.97912 3.43467 4.97787 3.42839C4.97653 3.42204 4.97789 3.41557 4.98168 3.40981C5.08102 3.26299 5.12552 3.10216 5.11128 2.94116C5.09704 2.78017 5.02435 2.62386 4.89966 2.48579C4.89463 2.48034 4.89213 2.47412 4.89224 2.46771C4.89234 2.4613 4.89506 2.45509 4.90011 2.44979C4.90524 2.44442 4.91241 2.44003 4.92093 2.43733C4.92955 2.43456 4.93903 2.43341 4.94852 2.43407L4.94842 2.43388Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_16952_7786">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
